<div class="amount">
    <div class="amount__available">
        <div class="amount__available__image">
            <vl-icon icon="wallet" mod-large /> Uw huidig {{serviceTitle}}-saldo
        </div>
        <div class="amount__available__total">{{ formatCurrency(availableAmount) }}</div>
    </div>
</div>
